var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useContext } from 'react';
import { LocalizationProvider, MuiPickersAdapterContext, } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS } from 'date-fns/locale';
var defaultLocalizationProps = {
    dateAdapter: AdapterDateFns,
    adapterLocale: enUS,
};
export var WithLocalizationProvider = function (_a) {
    var _b;
    var children = _a.children;
    var muiPickersAdapterContext = useContext(MuiPickersAdapterContext);
    if (((_b = muiPickersAdapterContext === null || muiPickersAdapterContext === void 0 ? void 0 : muiPickersAdapterContext.utils) === null || _b === void 0 ? void 0 : _b.lib) &&
        muiPickersAdapterContext.utils.lib !== 'date-fns') {
        throw new Error('DatePickerInput: React-admin Enterprise Edition Date Picker components only support the date-fns library. Please use the date-fns adapter in the LocalizationProvider.');
    }
    return muiPickersAdapterContext ? (React.createElement(React.Fragment, null, children)) : (React.createElement(LocalizationProvider, __assign({}, defaultLocalizationProps), children));
};
